import React, { useMemo } from 'react';
import { TypedMemo } from '../../common/types';
import { SMLSectionTabs } from '../components/SMLSectionTabs/SMLSectionTabs';
import { datePickerParamName, rangeDaysParamName } from '../components/SMLDatePicker/consts';
import { chartsTabs, ChartsTabScreen } from './chartsTabs';
import { chartsMessages } from './chartsMessages';

/** A tab change keeps the date of the picker (design 5a: the picker stays when the tab changes). */
const CHARTS_KEPT_QUERY: readonly string[] = [datePickerParamName, rangeDaysParamName];

interface ChartsTabRowProps {
  /** The tab on screen. */
  screen: ChartsTabScreen;
  /** The row sits in the page head (a phone, design navigation-v2 g 7c): no space under it. */
  inHead?: boolean;
}

/** The Trends · Artists · Tracks · Playlists · Markets row under the Charts title (design navigation-v2 e). */
const ChartsTabRowComponent: React.FC<ChartsTabRowProps> = ({ screen, inHead = false }) => {
  const tabs = useMemo(() => chartsTabs(screen), [screen]);
  const row = <SMLSectionTabs tabs={tabs} ariaLabel={chartsMessages.title} keepQuery={CHARTS_KEPT_QUERY} />;
  return inHead ? row : <div className="mb-3">{row}</div>;
};

export const ChartsTabRow = TypedMemo(ChartsTabRowComponent);
